<template>
    <div class="wrapper">
            <div :class="activeTab !== 'postProduct' ? 'menuWrapper' : 'menuWrapperHidden'">
                <productsMenu 
                    ref="productsMenuComp"
                    @openShippingProfile="activateTab('shippingProfile')"
                    @openProductList="activateTab('products')"
                />
            </div>
        <div class="mainBody" v-if="render && shopProducts">
            <div v-if="activeTab != 'shippingProfile'" style="display: flex; flex-wrap: wrap; column-gap: 10px; row-gap: 15px; margin-bottom: 20px;">
                <Button
                    @click="activateTab('postProduct')"
                    label="Lisa uus toode"
                    icon="pi pi-plus" 
                    severity="info" 
                    v-if="activeTab != 'postProduct' && activeTab != 'productsTable' && activeTab != 'manageCategories'"
                />
                <Button
                    @click="activateTab('productsTable')" 
                    label="Toodete tabel"
                    icon="pi pi-table" 
                    severity="info" 
                    outlined
                    v-if="activeTab != 'postProduct' && activeTab != 'productsTable' && activeTab != 'manageCategories'"
                    style="background-color: rgb(255,255,255, .8)" 
                />
                <Button
                    @click="activateTab('manageCategories')"
                    label="Kategooriahaldus"
                    icon="pi pi-sitemap" 
                    severity="info" 
                    outlined
                    v-if="activeTab != 'postProduct' && activeTab != 'productsTable' && activeTab != 'manageCategories'"
                    style="background-color: rgb(255,255,255, .8);" 
                />
                <Button
                    @click="activateTab('productsTable')"
                    label="Sulge"
                    icon="pi pi-times" 
                    severity="warn" 
                    outlined
                    v-if="activeTab == 'manageCategories'"
                    style="background-color: rgb(255,255,255, .8);" 
                />
            </div>
            <div v-if="shopProducts.length == 0 && activeTab == 'products'">
                <h2 style="font-size: 90px;color: rgb(225,225,225)">Tooted puuduvad</h2>
                <img 
                    :src="require('../assets/noListings.svg')"
                    alt="logo"
                    width="760px"
                    style="opacity: .3; margin-top: 00px;"
                />
            </div>
            <div class="singleTab" v-if="activeTab == 'products'">
                <productCard
                    ref="productCardComp"
                    v-for="(element, index) in shopProducts" :key="index"
                    @patchListingAccess="patchListingAccess"
                    @deleteListing="deleteProduct([{'idListing': element.idListing}])"
                    :successAnimationActive="successAnimationActive"
                    :singleListingData="element"
                    :index="index"
                    :shopData="shopData"
                    />
                </div>
                
                <div style="overflow: hidden; box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.15); border-radius: 20px;" v-if="activeTab == 'productsTable'">
                    <productsTable
                        ref="productsTableRef"
                        @activateTab="activateTab"
                        @patchListingAccess="patchListingAccess"
                        @patchProductData="patchProductData"
                        @tempSuccessMsg="successAnimationActive = true"
                        @resetPreviousDrawer="successAnimationActive = false"
                        @deleteSelectedProducts="deleteProduct"
                        @patchProductStock="patchProductStock"
                        :shopProducts="shopProducts"
                        :allCategories="allCategories"
                        :successAnimationActive="successAnimationActive"
                    />
                </div>
                
            <div v-if="activeTab == 'postProduct'" style="margin-bottom: 15px; margin-top: 50px;">
                <Button icon="pi pi-check-circle" label="Kinnita andmed" severity="success" @click="initPostProduct()"/>
                <Button icon="pi pi-ban" severity="secondary" label="Tühista" @click="activateTab('products')" outlined style="background: white; margin-left: 10px"/>
            </div>

            <div class="singleTab" v-if="activeTab == 'postProduct'" style="padding-bottom: 120px;">
                <Message class="errorMessage" severity="error" icon="pi pi-times-circle" size="large" :life="20000" v-if="errors">{{errors}}</Message>
                <productData ref="productDataComp" @processProductData="processProductData" @imageError="imageError" />
                <shippingData ref="shippingDataComp" @processShippingData="processShippingData" />
                <pricingData ref="pricingDataComp" @processPricingData="processPricingData" />
            </div>

            <div class="singleTab" style="column-gap: 20px; row-gap: 10px;" v-if="activeTab == 'shippingProfile'">
                <shippingMethodCard 
                    v-for="(item, index) in fullMethodsData" :key="index"
                    :shippingMethod="item"
                    @activateMethodDrawer="activateDrawer(item)"
                    @deleteShippingMethod="deleteShippingMethod"
                />

                <shippingMethod 
                    :shippingMethod="activeMethodDrawer"
                    :idShippingProfile="shippingProfile.idShippingProfile"
                    :successAnimationActive='successAnimationActive'
                    :errorMessages="shippingMethodError"
                    @shippingMethod="shippingMethod"
                    @turnOffAnimation="turnOffAnimation"
                    v-if="activeMethodDrawer"
                    ref="methodDrawer"
                />
            </div>

            <div class="singleTab" style="justify-content: space-between" v-if="activeTab == 'manageCategories'">
                <div class="postCategory">
                    <h2 style="margin-top: 0">Loo uus kategooria</h2>
                    <Select v-model="selectedParentCategory" style="margin-right: 10px" :options="allCategories" optionLabel="data.name" placeholder="Vali peakategooria" class="w-full md:w-56" />
                    <br><br>
                    <InputText v-model="requestedTagName" type="text" size="large" placeholder="Kategooria nimi" style="margin-bottom: 10px; width: 350px" />
                    <br>
                    <InputText v-model="requestedTagNameEn" type="text" size="large" placeholder="Kategooria nimi (Inglise keeles)" style="margin-bottom: 10px; width: 350px" />
                    <br>

                    <Button
                        @click="postListingTag()"
                        label="Kinnita uus kategooria"
                        icon="pi pi-plus" 
                        severity="success" 
                        style="margin-top: 15px" 
                    />
                </div>
                <div class="categoryTree" style="overflow: hidden; box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.15)">
                    <TreeTable :value="allCategories" tableStyle="min-width: 60rem;">
                        <template #header>
                            <div class="text-xl font-bold"><h2 style="margin: 0">Kategooriad</h2></div>
                        </template>
                        <Column field="name" header="Nimi" expander></Column>
                        <Column field="isActive" header="Kas aktiivne"></Column>
                        <Column field="listingsCount" header="Tooteid"></Column>
                        <Column field="children" header="Alakategooriaid"></Column>
                        <Column style="width: 5rem">
                            <template #body="props">
                                <div class="flex flex-wrap gap-2" style="display: flex; column-gap: 10px">
                                    <Button @click="deleteListingTag(props.node.key)" v-if="props.node.key != 15" type="button" icon="pi pi-trash" rounded outlined severity="danger" />
                                    <Button @click="editCategory(props.node.key, 0)" v-if="props.node.data.isActive == 1 && props.node.key != 15" type="button" icon="pi pi-lock" rounded outlined severity="warn" />
                                    <Button @click="editCategory(props.node.key, 1)" v-if="props.node.data.isActive == 0 && props.node.key != 15" type="button" icon="pi pi-unlock" rounded outlined severity="success" />
                                </div>
                            </template>
                        </Column>
                    </TreeTable>
                </div>
            </div>
        </div>
        
    </div>
</template>
  
<script>
import productsMenu from '@kristjan87/storium-workboard-library/src/components/main/products/menu/menu.vue';
import productsTable from '@kristjan87/storium-workboard-library/src/components/main/products/table/table.vue';
import productCard from '@kristjan87/storium-workboard-library/src/components/main/products/singleProduct/card/card.vue';

import productData from '@kristjan87/storium-workboard-library/src/components/main/products/singleProduct/post/product.vue';
import pricingData from '@kristjan87/storium-workboard-library/src/components/main/products/singleProduct/post/pricing.vue';
import shippingData from '@kristjan87/storium-workboard-library/src/components/main/products/singleProduct/post/shipping.vue';

import shippingMethods from '@kristjan87/storium-workboard-library/src/components/main/shipping/shippingMethods';
import shippingMethodCard from '@kristjan87/storium-workboard-library/src/components/main/shipping/singleMethod/card/card.vue';
import shippingMethod from '@kristjan87/storium-workboard-library/src/components/main/shipping/singleMethod/singleMethod.vue';

import Button from 'primevue/button'
import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import TreeTable from 'primevue/treetable';
import Column from 'primevue/column';
import Message from 'primevue/message';

import core from '../api/index'
export default {
    name: 'productsView',
    components: {
        productsMenu,
        productsTable,
        productCard,

        productData,
        pricingData,
        shippingData,

        shippingMethodCard,
        shippingMethod,

        Button,
        InputText,
        Select,
        TreeTable,
        Column,
        Message
        
    },
    props: {
        idShop: null,
        shopData: null,
        shopProducts: [],
        shippingProfile: null
    },
    watch: {
        shippingProfile: {
            handler(newVal) {
                if (newVal) {
                    this.render = true
                    this.setShippingMethods()
                    // this.setShopData()
                }
            },
            immediate: true, // Executes the watcher immediately on component creation
            deep: true // Watches the nested properties if needed
        },
        activeTab: {
            handler(newVal) {
                if (newVal == 'postProduct') {
                    this.postBtnToggle = true
                    this.tableBtnToggle = false
                } else if (newVal == 'productsTable') {
                    this.tableBtnToggle = true
                    this.postBtnToggle = false
                } else {
                    this.postBtnToggle = false
                    this.tableBtnToggle = false
                }
            },
        },
        shopProducts: {
            handler(newVal) {
                if(newVal) {
                    setTimeout(() => {
                        this.successAnimationActive = false
                    }, 2000)
                }
            },
        }
    },
    data() {
        return {
            render: false,
            activeTab: 'products',
            shippingMethods: shippingMethods(),
            fullMethodsData: null,
            activeMethodDrawer: null,
            selectedParentCategory: null,

            methodDrawerActive: false,
            tableBtnToggle: false,
            postBtnToggle: false,

            productDataPayload: null,
            shippingDataPayload: null,
            pricingDataPayload: null,

            allCategories: null,
            requestedTagName: null,
            requestedTagNameEn: null,

            errors: null,
            successAnimationActive: false,
            shippingMethodError: null
        };
    },
    computed: {
      
    },
    methods: {
        turnOffAnimation() {
            this.successAnimationActive = false
            this.shippingMethodError = null
        },

        activateTab(newActiveTab) {
            this.activeMethodDrawer = null
            if(newActiveTab != this.activeTab) {
                this.activeTab = newActiveTab
            } else {
                this.activeTab = 'products'
            }
        },

        activateDrawer(method) {
            this.activeMethodDrawer = method
            setTimeout(() => {
                this.$refs.methodDrawer.visible = true
            }, 1)
        },

        setShippingMethods() {
            this.fullMethodsData = this.shippingMethods

            // First, deactivate all methods
            this.fullMethodsData.forEach(method => {
                method.isMethodActive = false; // Deactivate all by default
            });

            // Then, activate only the methods found in shippingProfile.shippingMethods
            this.shippingProfile.shippingMethods.forEach(activeMethod => {
                let method = this.fullMethodsData.find(method => method.option === activeMethod.shippingOption);
                if (method) {
                    method.isMethodActive = true;
                    method.attr = activeMethod.attr;
                    method.idShippingMethod = activeMethod.idShippingMethod;
                }
            });
        },

        imageError() {
            this.errors = 'Tootel puudub kaanepilt!'
        },

        initPostProduct() {
            this.$refs.productDataComp.initPostProduct()
        },

        processProductData(obj) {
            this.productDataPayload = obj

            this.$refs.shippingDataComp.initPostProduct()
        },

        processShippingData(obj) {
            this.shippingDataPayload = obj

            this.$refs.pricingDataComp.initPostProduct()
        },

        processPricingData(obj) {
            this.pricingDataPayload = obj

            this.postProduct()
        },

        postProduct() {           
            this.errors = null

            let payload = this.productDataPayload.payloadForm

            payload.append('body', JSON.stringify({
                idShop: this.idShop,
                title: this.productDataPayload.titleText,
                description: this.productDataPayload.descriptionText,
                tags: [15],
                filterParams: [],
                price: Number(this.pricingDataPayload.price),
                coverImg: this.productDataPayload.coverImg,
                deliveryTime: Number(this.shippingDataPayload.deliveryTime),
                stockQuantity: Number(this.shippingDataPayload.stockQuantity),
                sku: this.shippingDataPayload.sku,
                attr: {
                    dimensions: {
                        weight: Number(this.shippingDataPayload.weight),
                        width: Number(this.shippingDataPayload.width),
                        height: Number(this.shippingDataPayload.height),
                        depth: Number(this.shippingDataPayload.depth) 
                    }
                },
            }))
            fetch(this.$fetchIp+'/v2/listing/', {
                method: 'POST',
                credentials: 'include',
                body: payload
            })
            .then((res) => res.json())
            .then((res) => {
                if(res.status === 'success') {
                    this.$emit('getShopProducts')
                    
                    setTimeout(() => {
                        this.activateTab('products')
                    }, 100)
                }
                if(res.statusCode === 413) {
                    this.errors = 'Üks valitud piltidest ületab maksimaalse lubatud pildi suuruse.'
                }
                if(res.message === 'The cover image was not sent to the server that was set to be it.') {
                    this.errors = 'Toote piltide alt on valimata kaanepilt.'
                }
                if(res.message === 'SKU must contain only letters, numbers, dashes or underscores, be 1-50 characters long, and cannot contain spaces or special characters. Example of valid SKU: "PRODUCT-123" or "winter_boots_2024"') {
                    this.errors = 'Tootekood tohib sisestada ainult numbreid, tähti, kriispu ja alakriipsu. (näide: "PRODUCT-123" või "winter_boots_2024")'
                }
                if(res.message === 'Something went wrong, please try again or contact support.') {
                    this.errors = 'Midagi läks valesti, palun proovige uuesti või kontakteeruge kasutajatoega.'
                }
                if(res.message === 'Images must be provided when creating a new listing.') {
                    this.errors = 'Puuduvad toote pildid.'
                }
                if(res.message === 'Title length must be atleast 10 characters.') {
                    this.errors = 'Pealkirja pikkus peab olema vähemalt 10 tähemärki.'
                }
                if(res.message === 'Title length must not exceed 100 characetrs.') {
                    this.errors = 'Pealkirja pikkus ei saa olla rohkem kui 100 tähemärki.'
                }
                if(res.message === 'Description length must be atleast 50 characters.') {
                    this.errors = 'Kirjelduse pikkus peab olema vähemalt 50 tähemärki.'
                }
                if(res.message === 'Description length cannot exceed 4999 characters.') {
                    this.errors = 'Kirjelduse pikkus ei saa olla rohkem kui 4999 tähemärki.'
                }
                if(res.message === 'Listing must have a price.') {
                    this.errors = 'Kuulutusel puudub hind.'
                }
                if(res.message === 'Price is too high.') {
                    this.errors = 'Määratud hind ei saa olla rohkem kui 9999 eurot.'
                }
                if(res.message === 'One of the tags is invalid.') {
                    this.errors = 'Kategooria on valimata'
                }
                if(res.message === 'All dimensions must be more than zero.') {
                    this.errors = 'Sisestage kõik toote mõõdud.'
                }
                if(res.message === 'All dimensions must be of type number.') {
                    this.errors = 'Toote mõõdud peavad olema numbrid.'
                }
                if(res.message === 'Price of the listing must be a valid currency number.') {
                    this.errors = 'Hind peab olema valiidne number, mitte rohkem kui kaks komakohta.'
                }
                if(res.message === ' Shop must have atleast one shipping method before adding listings.') {
                    this.errors = 'Enne kui on võimalik luua kuulutusi, tuleb sätestada vähemalt üks tarnemeetod'
                }
                if(res.message === 'Not possible to add listing to root category.') {
                    this.errors = 'Kuulutust pole võimalik lisada juurkategooriasse.'
                }
                if(res.message === 'Provided cover image wasnt in an accepted image format.') {
                    this.errors = 'Valitud kaanepilt ei ole aktsepteeritud formaadis.'
                }
                if(res.message === 'Tags with the provided ids were not found from the database.') {
                    this.errors = 'Viga kategooria valimisel, proovige uuesti.'
                }
                if(res.message === 'Not possible to create a child for a uncategorized tag.') {
                    this.errors = 'Kategoriseerimata kategooriale ei ole võimalik alakategooriat luua.'
                }
                if(res.message === 'Not possible to add listing to root category.') {
                    this.errors = 'Juurkategooriasse ei ole võimalik kuulutust lisada, peate valima alakategooria.'
                }
                if(res.message === 'Delivery time must be more than 0 and less or equal to 90.') {
                    this.errors = 'Väljasaatmise aeg peab olema number 0-90'
                }
                if(res.statusCode == 413) {
                    this.errors = 'Piltide suurus megabaitides ületab lubatud maksimumi.'
                }
                this.isLoading = false
            })
        },

        patchProductStock(payload, idListing) {
            fetch(this.$fetchIp+'/v2/stock/'+idListing, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify(payload)
            })
            .then((res) => res.json())
            .then((res) => {
                if(res.status === 'success') {
                    this.successAnimationActive = true
                    setTimeout(() => {
                        this.successAnimationActive = false
                    }, 1500)
                    this.$emit('getShopProducts')
                }
                if(res.data.error === 'Stock quantity must be a non-negative integer or null.') {
                    this.error = 'Laoseis peab olema number.'
                }
            })
        },

        patchProductData(payload, idListing) {
            core.listingApi.patchListing({
                pathParam: idListing,
                body: payload
            })
            .then((res) => {
                if(res.status === 'success') {
                    this.error = null
                    this.successAnimationActive = true
                    setTimeout(() => {
                        this.successAnimationActive = false
                    }, 1500)
                    this.$emit('getShopProducts')
                }
                if(res.statusCode === 413) {
                    this.error = 'Üks valitud piltidest ületab maksimaalse lubatud pildi suuruse.'
                }
                if(res.message === 'Something went wrong, please try again or contact support.') {
                    this.error = 'Midagi läks valesti, palun proovige uuesti või kontakteeruge kasutajatoega.'
                }
                if(res.message === 'Delivery time must be more than 0 and less or equal to 90.') {
                    this.error = 'Toote väljasaatmise aeg ei saa olla 0 päeva, samuti mitte rohkem kui 90 päeva. Ajavahemikke sisestada ei ole võimalik'
                }
                if(res.message === 'Cover image must be in the array that holds all images. Try setting new cover image before.') {
                    this.error = 'Toote piltide alt on valimata kaanepilt.'
                }
                if(res.message === 'Images have to be supplied.') {
                    this.error = 'Puuduvad toote pildid.'
                }
                if(res.message === 'Title length must be atleast 10 characters.') {
                    this.error = 'Pealkirja pikkus peab olema vähemalt 10 sõnamärkki.'
                }
                if(res.message === 'Images must be supplied when setting new cover image.') {
                    this.error = 'Toote piltide alt on valimata kaanepilt.'
                }
                if(res.message === 'Title length must not exceed 100 characetrs.') {
                    this.error = 'Pealkirja pikkus ei saa olla rohkem kui 100 tähemärki.'
                }
                if(res.message === 'Description length must be atleast 50 characters.') {
                    this.error = 'Kirjelduse pikkus peab olema vähemalt 50 sõnamärkki.'
                }
                if(res.message === 'Description length cannot exceed 4999 characters.') {
                    this.error = 'Kirjelduse pikkus ei saa olla rohkem kui 4999 tähemärki.'
                }
                if(res.message === 'Listing must have a price.') {
                    this.error = 'Kuulutusel puudub hind.'
                }
                if(res.message === 'Price is too high.') {
                    this.error = 'Määratud hind ei saa olla rohkem kui 9999 eurot.'
                }
                if(res.message === 'Listing must have atleast one tag.') {
                    this.error = 'Kategooria on valimata'
                }
                if(res.message === 'Not possible to create a child for a uncategorized tag.') {
                    this.error = 'Kategoriseerimata kategooriale ei ole võimalik alakategooriat luua.'
                }
                if(res.message === 'All dimensions must be more than zero.') {
                    this.error = 'Sisestage kõik toote mõõdud.'
                }
                if(res.message === 'All dimensions must be of type number.') {
                    this.error = 'Toote mõõdud peavad olema numbrid.'
                }
                if(res.message === 'Price of the listing must be a valid currency number.') {
                    this.error = 'Hind peab olema valiidne number, mitte rohkem kui kaks komakohta.'
                }
                if(res.message === 'Not possible to add listing to root category.') {
                    this.error = 'Kuulutust pole võimalik lisada juurkategooriasse.'
                }
                if(res.message === 'Tags with the provided ids were not found from the database.') {
                    this.error = 'Viga kategooria valimisel, proovige uuesti.'
                }
                if(res.message === 'Not possible to add listing to root category.') {
                    this.error = 'Juurkategooriasse ei ole võimalik kuulutust lisada, peate valima alakategooria.'
                }
                if(res.statusCode == 413) {
                    this.error = 'Piltide suurus megabaitides ületab lubatud maksimumi.'
                }
            })
        },

        patchListingAccess(method, idListing) {
            fetch(this.$fetchIp+'/v2/listing/access/'+idListing+'?operation='+method, {
                method: 'PATCH',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
            })
            .then((res) => res.json())
            .then((res) => {
                if(res.status === 'success') {
                    this.successAnimationActive = true
                    setTimeout(() => {
                        this.successAnimationActive = false
                    }, 1500)
                    this.$emit('getShopProducts')
                }
            })
        },

        deleteProduct(selectedProducts) {
            this.$confirm.require({
                message: 'Oled kindel, et soovid toote(d) kustutada?',
                header: 'Kinnitus',
                icon: 'pi pi-exclamation-triangle',
                rejectProps: {
                    label: 'Tühista',
                    severity: 'secondary',
                    outlined: true
                },
                acceptProps: {
                    label: 'Kinnita'
                },
                accept: () => {
                    for(const element of selectedProducts) {
                        fetch(this.$fetchIp+'/v2/listing/'+element.idListing, {
                            method: 'DELETE',
                            headers: {
                                'Content-type':'application/json',
                                'Authorization': 'salaTokken'
                            },
                            credentials: 'include',
                        })
                        .then((res) => res.json()) 
                        .then((res) => {
                            if(res.status === 'success') {
                                this.$toast.add({ severity: 'info', summary: 'Kinnitatud', detail: 'Toode on kustatud!', life: 5000 });
                            }
                        })
                    }
                    setTimeout(() => {
                        this.$emit('getShopProducts')
                        this.$refs.productsTableRef.selectedProducts = []
                    }, 1);
                },
            });
        },

        shippingMethod(methodData, method, idEntity) {
            let sendBody
            if(method == 'PATCH') {
                sendBody = {"changes": methodData}
            } else {
                sendBody = methodData
            }
            fetch(this.$fetchIp+'/v2/shipping/method/'+idEntity, {
                method: method,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify(sendBody)
            })
            .then((res) => res.json())
            .then((res) => {
                if(res.status === 'success') {
                    this.successAnimationActive = true
                    this.$emit('getShippingProfile')
                    setTimeout(() => {
                        this.$refs.methodDrawer.visible = false
                        this.activeMethodDrawer = null
                        this.successAnimationActive = false
                    }, 1500)
                }
                this.shippingMethodError = null
                if(res.message == 'Parcel method extra info must be less than 2000 characters.') {
                    this.shippingMethodError = 'Lisainfo ei tohi olla pikem kui 2000 sõnamärkki.'
                }
                if(res.message == 'Atleast one supported parcel terminal must be provided.') {
                    this.shippingMethodError = 'Valitud peab olema vähemalt üks tarnija.'
                }
                if(res.message == 'Minimum shipping option order amount must be a valid currency amount.') {
                    this.shippingMethodError = 'Minimaalne tellimuse väärtus ei ole valiidne(lubatud on 2 komakohta, koma asemel tuleb kasutada punkti)'
                }
                if(res.message == 'Parcel delivery free delivery threshold must be of type number.') {
                    this.shippingMethodError = 'Tasuta transpordi künnis ei ole valiidne (lubatud on 2 komakohta, koma asemel tuleb kasutada punkti).'
                }
                if(res.message == 'Merchant delivery perKm pricing model must contain atleast one delivery range.') {
                    this.shippingMethodError = 'Sisestama peab vähemalt ühe kilomeetri hinna ja vastava maksimaalse kauguse.'
                }
                if(res.message == 'Per km pricing model range must be of type number and not less or equal to zero.') {
                    this.shippingMethodError = 'Maksimaalne kaugus ei saa olla 0km.'
                }
                if(res.message == 'Merchant delivery perKm pricing model ranges must have price and it a valid currency number.') {
                    this.shippingMethodError = 'Kaupleja tarne kilomeetri hinna või maksimaalse kauguse number on ebakorrektne, komakoha määramiseks kasuta punkti.'
                }
                if(res.message == 'Missing an address element.') {
                    this.shippingMethodError = 'Tarnemeetodi aadressist on puudu andmed(näiteks majanumber).'
                }
                if(res.message == 'Minimum shipping option order amount must be a valid currency amount.') {
                    this.shippingMethodError = 'Minimaalne tehingu summa alates millest on transport tasuta, peab olema valiidne number.'
                }
                if(res.message == 'Merchant delivery free range cannot be more than 500,000m.') {
                    this.shippingMethodError = 'Tasuta transpordi maksimaalne kaugus ei saa olla rohkem kui 500km.'
                }
                if(res.message == 'Merchant delivery perKm pricing model range cannot be more than 500,000m.') {
                    this.shippingMethodError = 'Maksimaalne transpordi kaugus ei saa olla rohkem kui 500km.'
                }
                if(res.message == 'Param "extraInfo" must be of type string.') {
                    this.shippingMethodError = 'Kokkuleppe tarnemeetodi lisainfo sisestamine on kohustuslik.'
                }
            })
        },

        deleteShippingMethod(idShippingMethod) {
            this.$confirm.require({
                message: 'Oled kindel, et soovid tarnemeetodi kustutada?',
                header: 'Kinnitus',
                icon: 'pi pi-exclamation-triangle',
                rejectProps: {
                    label: 'Tühista',
                    severity: 'secondary',
                    outlined: true
                },
                acceptProps: {
                    label: 'Kinnita'
                },
                accept: () => {
                    fetch(this.$fetchIp+'/v2/shipping/method/'+idShippingMethod, {
                        method: 'DELETE',
                        headers: {
                            'Content-type':'application/json'
                        },
                        credentials: 'include',
                    })
                    .then((res) => res.json()) 
                    .then((res) => {
                        if(res.status === 'success') {
                            this.activeMethodDrawer = null
                            this.$emit('getShippingProfile')
                            this.$toast.add({ severity: 'info', summary: 'Kinnitatud', detail: 'Tarnemeetod on kustatud!', life: 5000 });
                        }
                        if(res.message === 'Not possible to remove all methods from a shipping profile.') {
                            this.activeMethodDrawer = null
                            this.$toast.add({ severity: 'warn', summary: 'Veateade', detail: 'Igal poel peab olema vähemalt üks tarnemeetod', life: 5000 });
                        }
                    })
                },
            });
        },

        getAllCategories() {
            core.tagApi.listingTagApi.getListingTagTree()
            .then((res) => {
                this.allCategories = this.transformCategoriesToTreeNodes(res.data.categoriesTree);
            })
            .catch(error => {
                console.error("Failed to fetch categories:", error);
            });
        },
        transformCategoriesToTreeNodes(categories) {
            return categories.map((category) => ({
                key: category.idListingTag,
                data: {
                    name: category.name,
                    listingsCount: category.listingsCount,
                    isActive: category.isActive,
                    children: category.children.length
                },
                children: category.children.length
                ? this.transformCategoriesToTreeNodes(category.children)
                : [],
            }));
        },

        postListingTag() {
            let idListingTagParent
            if(this.selectedParentCategory) {
                idListingTagParent = this.selectedParentCategory.key
            } else {
                idListingTagParent = null
            }
            core.tagApi.listingTagApi.postListingTag({
                // pathParam: this.idShop,
                body: {
                    "idListingTagParent": idListingTagParent,
                    "name": this.requestedTagName,
                    "isActive": true,
                    "translations": {
                        "et": this.requestedTagName,
                        "en": this.requestedTagNameEn
                    },
                    "attr": {"idShop": this.idShop},
                }
            })
            .then((res) => {
                if(res.status == 'success') {
                    this.getAllCategories()
                    this.selectedParentCategory = null
                    this.requestedTagName = null
                    this.requestedTagNameEn = null
                    this.$toast.add({ severity: 'success', summary: 'Kinnitatud', detail: 'Uus tootekategooria loodud!', life: 5000 });
                }
                if(res.message == 'Type of each translation must be a string.') {
                    this.requestError = 'Eesti ja Inglise keele tõlke sisestamine on kohustuslik'
                } 
            })
        },

        editCategory(idListingTag, isActive) {
            let isActiveBoolean
            if(isActive == 0) {
                isActiveBoolean = false
            }
            if(isActive == 1) {
                isActiveBoolean = true
            }
            core.tagApi.listingTagApi.patchListingTagData({
                pathParam: idListingTag,
                body: {"changes": {"isActive": isActiveBoolean}}
            })
            .then((res) => {
                if(res.message == 'Not possible to deactivate a tag to which or to which descendants is assigned 1 or more listings.') {
                    this.$toast.add({ severity: 'warn', summary: 'Veateade', detail: 'Deaktiveerimiseks peab kategooria olema tühi!', life: 5000 });
                } 
                if(res.status == 'success') {
                    this.getAllCategories()
                    if(isActive == 0) {
                        this.$toast.add({ severity: 'success', summary: 'Kinnitatud', detail: 'Kategooria muudetud ebaaktiivseks!', life: 5000 });
                    }
                    if(isActive == 1) {
                        this.$toast.add({ severity: 'success', summary: 'Kinnitatud', detail: 'Kategooria muudetud aktiivseks!', life: 5000 });
                    }
                }
            })
        },

        deleteListingTag(idListingTag) {
            this.$confirm.require({
                message: 'Oled kindel, et soovid kategooria kustutada? Kustutamiseks peab olema kategooria tühi.',
                header: 'Kinnitus',
                icon: 'pi pi-exclamation-triangle',
                rejectProps: {
                    label: 'Tühista',
                    severity: 'secondary',
                    outlined: true
                },
                acceptProps: {
                    label: 'Kinnita'
                },
                accept: () => {
                    core.tagApi.listingTagApi.deleteListingTag({
                        pathParam: idListingTag,
                    })
                    .then((res) => {
                        if(res.status == 'success') {
                            this.getAllCategories()
                            this.$toast.add({ severity: 'success', summary: 'Kinnitatud', detail: 'Kategooria kustutatud!', life: 5000 });
                        }
                        if(res.message == 'Not possible to delete an active listing tag, change it to deactive first.') {
                            this.$toast.add({ severity: 'warn', summary: 'Veateade', detail: 'Kustutamiseks pead kategooria ennem deaktiveerima!', life: 5000 });
                        } 
                    })
                },
            });
        },
    },
    created() {
      // Lifecycle hook - called after the instance is created
        this.getAllCategories()
    },
    mounted() {
        
    },
    updated() {
      // Lifecycle hook - called after a data change causes the DOM to re-render
    
    },
  };
</script>
<style>
.p-toast-message-info {
    --p-toast-info-background: white;
    overflow: hidden;
}
.p-togglebutton.p-component.p-togglebutton-checked {
    background: rgb(211, 222, 236);
    border: 1px solid rgb(211, 222, 236);
}
.p-togglebutton.p-component {
    background: rgb(255, 255, 255);
    border: 1px solid rgb(211, 222, 236);
}
.p-togglebutton:not(:disabled):not(.p-togglebutton-checked):hover {
    --p-togglebutton-hover-background: rgb(211, 222, 236)
}
</style>
<style scoped>
.wrapper {
    background: rgb(238, 242, 245);
    height: 100%;
    min-height: 100vh;
    margin: 0;
    padding-bottom: 50px;
}
.menuWrapper {
    display: fixed;
    transition: .3s;
}
.menuWrapperHidden {
    margin-top: -120px;
    transition: .3s;
}
.mainBody {
    position: relative;
    width: 1420px;
    margin: 0 auto;
    padding-top: 130px;
}
.singleTab {
    display: flex;
    flex-wrap: wrap;
    row-gap: 35px;
    column-gap: 40px;
}
.errorMessage {
    position: absolute;
    width: 478px;
    z-index: 1;
    text-align: start;
    padding-bottom: 1px;
    padding-top: 2px;
}
@media (max-width: 1470px) {
    .mainBody {
        width: 100%;
        padding-left: 25px;
        padding-right: 25px;
    }
}
@media (max-width: 500px) {
    .menuWrapper {
        padding-top: 67px;
    }
}
@media (max-width: 375px) {
    .mainBody {
        width: 100%;
        padding-left: 15px;
        padding-right: 15px;
    }
}
</style>